import video_activity from '@/../images/icons/video-activity.svg';
import classroom_activity from '@/../images/icons/hands-on.svg';
import lesson_outline from '@/../images/icons/lesson-outline.svg';
import reading from '@/../images/icons/reading.svg';
import reading_activity from '@/../images/icons/reading-white.svg';

export const ICON_MAP = {
  classroom_activity,
  investigation: classroom_activity,
  lesson_outline,
  professional_development: classroom_activity,
  reading,
  reading_activity,
  video_activity,
};

export const shouldRenderSlideShow = (slideShow, bigBookSlideshow?: boolean) => {
  // The conditional can be removed entirely when bigBookSlideshow flag is removed.
  if (slideShow.activityType === 'reading_activity' && !bigBookSlideshow) return false;

  if (slideShow.useForInvestigations) return false;
  if (slideShow.useForUnitProjects) return false;
  if (!slideShow.activityType) return false;
  if (slideShow.activityType === 'marketing') return false;

  return true;
};
